import * as qs from 'query-string'
import { AxiosResponse, AxiosRequestConfig } from 'axios'

import { ApplicationStatus } from '../interfaces/ApplicationStatus.interface'
import { JobApplicantComment } from '../interfaces/JobApplicantComment.interface'
import { ApplicationFilterParameters } from '../interfaces/ApplicationFilterParameters.interface'

import { employeesApi } from './'

export interface ApplicationUpdateRequest {
  city?: string
  state?: string
  street?: number
  driverLicenseNumber?: string
  driverLicenseExpirationDate?: string
}

export const fetchApplication = (applicationId: string) => (
  employeesApi.get(`/application/admin/${applicationId}`)
    .then((response: AxiosResponse) => response.data)
)

export const fetchApplicationFiles = (applicationId: string) => (
  employeesApi.get(`/application/admin/${applicationId}/files`)
    .then((response: AxiosResponse) => response.data)
)

export const uploadApplicationFile = (applicationId: string, file: any) => {
  const formData = new FormData()
  formData.append('file', file)

  return employeesApi.post(`/application/admin/${applicationId}/files`, formData)
    .then((response: AxiosResponse) => response.data)
}

export const getJobLocationPositions = () => {
  return employeesApi.get('/application/admin/positions')
    .then((response: AxiosResponse) => response.data)
}

export const openPosition = (locationJobPositionId: number) => {
  return employeesApi.put(`/application/admin/positions/${locationJobPositionId}`)
    .then((response: AxiosResponse) => response.data)
}

export const closePosition = (locationJobPositionId: number) => {
  return employeesApi.delete(`/application/admin/positions/${locationJobPositionId}`)
    .then((response: AxiosResponse) => response.data)
}

export const fetchApplicationsList = (filterParams: ApplicationFilterParameters) => {
  const axiosConfig: AxiosRequestConfig = {
    params: filterParams,
    paramsSerializer: p => qs.stringify(p)
  }

  return employeesApi.get('/application/admin', axiosConfig)
    .then((response: AxiosResponse) => response.data)
}

export const fetchApplicationsSummary = (filterParams: ApplicationFilterParameters) => {
  const axiosConfig: AxiosRequestConfig = {
    params: filterParams,
    paramsSerializer: p => qs.stringify(p)
  }

  return employeesApi.get('/application/admin/summary', axiosConfig)
    .then((response: AxiosResponse) => response.data)
}

export const postApplicationComment = (applicationId: string, comment: string) => {
  return employeesApi.post<JobApplicantComment>(`/application/admin/${applicationId}/comment`, { comment })
    .then((response: AxiosResponse) => response.data)
}

export const updateApplicationStatus = (applicationId: string, status: ApplicationStatus) => (
  employeesApi.put(`/application/admin/${applicationId}/status/${status}`)
    .then((response: AxiosResponse) => response.data)
)

export const approveApplication = (applicationId: string) => (
  employeesApi.put(`/application/admin/${applicationId}/approve`)
    .then((response: AxiosResponse) => response.data)
)

export const convertApplicantToEmployee = (applicationId: string, employeeId: string) => (
  employeesApi.post(`/application/admin/${applicationId}/convert/${employeeId}`)
    .then((response: AxiosResponse) => response.data)
)

export const fetchNextEmployeeId = () => (
  employeesApi.get('/application/admin/next-id')
    .then((response: AxiosResponse) => response.data)
)

export const updateApplication = (applicationId: string, application: ApplicationUpdateRequest) => (
  employeesApi.put(`/application/admin/${applicationId}`, application)
    .then((response: AxiosResponse) => response.data)
)


// WEBPACK FOOTER //
// ./src/lib/api/applications.ts